import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { TasksContextProvider } from './context/tasks-content';
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "./Resourses/css/custom.css";
import AppRoute from './Routes/AppRoute';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render( 
<BrowserRouter>
  <TasksContextProvider>
    <AppRoute>
    </AppRoute>
  </TasksContextProvider>
    
</BrowserRouter>
);

